import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom';
import './index.css'
import './App.css';
import { CookiesProvider } from 'react-cookie';

import * as Sentry from "@sentry/react";
import { ErrorFallback } from './components/ErrorFallback.tsx';
import { ErrorBoundary } from "react-error-boundary";


if (import.meta.env.PROD) {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      integrations: [Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: true })],
      ignoreErrors: [ "Non-Error promise rejection captured" ],
    });
  }
  const script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.setAttribute('data-website-id', 'cbfe62f4-8e61-43a6-b775-77bf5affe608');
  script.src = 'https://cloud.umami.is/script.js';
  document.head.appendChild(script);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary FallbackComponent={ErrorFallback} onError={error => Sentry.captureException(error)}>
    <BrowserRouter>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
